<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chấm công bổ sung/ Nghỉ phép</h1>
      <div class="btn-group float-right">
        <DraggableTable :naming="$route.name" v-model="fieldTable" @change="filterTable = $event" />
        <button
          v-if="dataPermission && dataPermission.includes('CNPS_ATTN_ADD_CREATE')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="addTimekeeping"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button
          v-if="dataPermission && dataPermission.includes('CNPS_ATTN_ADD_EXPORT')"
          class="f12 font-medium btn btn-outline-secondary"
          @click="exportFile"
        >
          <i class="bx bx-download"></i> Xuất file
        </button>
        <button
          v-if="
            selectedStatus === 'WAITING' &&
            selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_ATTN_ADD_APPROVE_REJECT')
          "
          class="f12 font-medium btn btn-outline-secondary"
          @click="showApprovedModal"
        >
          Duyệt
        </button>
        <button
          v-if="
            selectedStatus === 'WAITING' &&
            selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_ATTN_ADD_APPROVE_REJECT')
          "
          class="f12 font-medium btn btn-outline-secondary"
          @click="showRefuseModal"
        >
          <span>&nbsp;</span>Từ chối
        </button>
        <button
          v-if="
            selectedStatus === 'APRROVED' &&
            selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_ATTN_ADD_ACCEPT')
          "
          class="f12 font-medium btn btn-outline-secondary"
          @click="showAcceptModal"
        >
          <span>&nbsp;</span>Xác nhận
        </button>
        <button
          v-if="
            selectedStatus === 'APRROVED' &&
            selected.length > 0 &&
            dataPermission &&
            dataPermission.includes('CNPS_ATTN_ADD_ACCEPT')
          "
          class="f12 font-medium btn btn-outline-secondary"
          @click="showNotAcceptModal"
        >
          <span>&nbsp;</span>Không xác nhận
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange1"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian BĐ - KT
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div
            class="form-group"
            v-if="saleAdmin.includes(typeSale) || superAdmin.includes(typeSale)"
          >
            <Select2
              placeholder="Vùng"
              v-model="search.regionId"
              :options="dataRegion"
              @change="queryListStaff($event)"
            />
          </div>
          <div
            class="form-group"
            v-if="
              saleAdmin.includes(typeSale) ||
              saleLeader.includes(typeSale) ||
              regionDirector.includes(typeSale) ||
              superAdmin.includes(typeSale)
            "
          >
            <Select2 placeholder="Quản lý" v-model="search.superiorId" :options="dataManager" />
          </div>
          <div class="form-group" v-if="!transSale.includes(typeSale)">
            <Select2 placeholder="Nhân viên" v-model="search.saleId" :options="dataStaff" />
          </div>
          <div class="form-group">
            <Select2 placeholder="Kiểu" v-model="search.type" :options="typeAddanceTimeKepping" />
          </div>
          <div class="form-group">
            <Select2
              placeholder="Trạng thái"
              v-model="search.status"
              :options="stateAddtionTimekepping"
            />
          </div>
          <div class="form-group">
            <Select2 placeholder="Loại CCBS" v-model="search.reasonAttnAdd" :options="listReason" />
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng bản ghi: {{ pagination.total }}
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataTable"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <b-form-checkbox
                  v-if="selected.length > 0"
                  v-model="stateCheckAll"
                  @change="checkAll"
                />
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox
                  :value="data.item.id"
                  v-model="selected"
                  @change="check(item)"
                  :disabled="
                    (data.item.status !== 'APRROVED' && data.item.status !== 'WAITING') ||
                    (data.item.status !== selectedStatus && selectedStatus !== null)
                  "
                />
              </template>
              <template #cell(staff)="data">
                <div v-if="data.item.staffInfo">
                  <b>{{ data.item.staffInfo.name }}</b> <br />
                  Vị trí: <b>{{ data.item.staffInfo.typeSale | transformData(listTypeSale) }}</b>
                  <br />
                  <a href="#" @click="openDetailStaff(data.item)">{{
                    data.item.staffInfo.userName
                  }}</a>
                </div>
              </template>
              <template #cell(province)="data">
                {{ data.item.staffInfo.provinceName }}
              </template>
              <template #cell(createdAt)="data">
                {{ data.item.createdDate | formatDate('HH:mm DD/MM/YYYY') }}
              </template>
              <template #cell(rangeTime)="data">
                <div
                  v-if="data.item.reasonAttnAdd && typeCheckInOut.includes(data.item.reasonAttnAdd)"
                >
                  <b>TG</b>: {{ data.item.startDate | formatDate }}
                </div>
                <div v-else>
                  <b>BĐ</b>: {{ data.item.startDate | formatDate('HH:mm:ss DD/MM/YYYY') }} <br />
                  <b>KT</b>: {{ data.item.endDate | formatDate('HH:mm:ss DD/MM/YYYY') }}
                </div>
              </template>
              <template #cell(manager)="data">
                <div v-if="data.item.managerInfo">
                  <b>{{ data.item.managerInfo.name }}</b> <br />
                  <a href="#">{{ data.item.managerInfo.userName }}</a>
                </div>
              </template>
              <template #cell(image)="data">
                <img
                  v-viewer
                  class="image"
                  :src="
                    data.item.imageUrl && data.item.imageUrl.length > 0 ? data.item.imageUrl[0] : ''
                  "
                  alt=""
                />
              </template>
              <template #cell(type)="data">
                {{ data.item.type | fomatTypeAddtionalKepping() }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | fomatStatusTextAdd() }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    v-if="dataPermission && dataPermission.includes('CNPS_ATTN_ADD_DETAIL')"
                    @click="detailTimekeeping(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'NEW' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_ATTN_ADD_UPDATE')
                    "
                    class="dropdown-item"
                    data-toggle="modal"
                    @click="editTimekeeping(data.item)"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      (data.item.status === 'WAITING' ||
                        data.item.status === 'APRROVED' ||
                        data.item.status === 'ACCEPT') &&
                      dataPermission &&
                      dataPermission.includes('CNPS_ATTN_ADD_UPDATE_EXCEPTION')
                    "
                    class="dropdown-item"
                    data-toggle="modal"
                    @click="editTimekeepingHR(data.item)"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'NEW' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_ATTN_ADD_SALE_REJECT')
                    "
                    class="dropdown-item"
                    data-toggle="modal"
                    @click="rejectTimekeeping(data.item)"
                    ><span>&nbsp;</span>Hủy
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'WAITING' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_ATTN_ADD_APPROVE_REJECT')
                    "
                    class="dropdown-item"
                    data-toggle="modal"
                    @click="approvedTimekeeping(data.item)"
                    ><span>&nbsp;</span>Duyệt
                  </b-dropdown-item>
                  <button
                    v-if="
                      data.item.status === 'WAITING' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_ATTN_ADD_APPROVE_REJECT')
                    "
                    class="dropdown-item"
                    data-toggle="modal"
                    @click="refuseTimekeeping(data.item)"
                  >
                    <span>&nbsp;</span>Từ chối
                  </button>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'APRROVED' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_ATTN_ADD_ACCEPT')
                    "
                    class="dropdown-item"
                    data-toggle="modal"
                    @click="acceptTimekeeping(data.item)"
                    ><span>&nbsp;</span>Xác nhận
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      data.item.status === 'APRROVED' &&
                      dataPermission &&
                      dataPermission.includes('CNPS_ATTN_ADD_ACCEPT')
                    "
                    class="dropdown-item"
                    data-toggle="modal"
                    @click="notAcceptTimekeeping(data.item)"
                    ><span>&nbsp;</span>Không xác nhận
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="fl-right mr-2"
        ></b-pagination>
      </div>
    </div>

    <!--Modal thông báo-->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" alt="icon-successs" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <!--Modal duyệt select-->
    <b-modal id="modal-scoped" v-model="approvedModal">
      <template #modal-header="{ close }">
        <h5>Duyệt chấm công</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img src="@/assets/img/noti-unsuccess2.svg" alt="question" />
        <h2 class="f18 py-3">Bạn chắc chắn duyệt chứ?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="approvedSelect()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal duyệt 1-->
    <b-modal id="modal-scoped" v-model="approvedOneModal">
      <template #modal-header="{ close }">
        <h5>Duyệt chấm công</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img src="@/assets/img/noti-unsuccess2.svg" alt="question" />
        <h2 class="f18 py-3">Bạn chắc chắn duyệt chứ?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="approved()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal từ chối select-->
    <b-modal id="modal-scoped" v-model="refuseModal">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <textarea v-model="textReason" class="form-control" :maxlength="225" rows="3"></textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="refuseSelect()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal từ chối 1-->
    <b-modal id="modal-scoped" v-model="refuseOneModal">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <textarea v-model="textReasonOne" class="form-control" :maxlength="225" rows="3"></textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="refuse()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal xác nhận select-->
    <b-modal id="modal-scoped" v-model="acceptModal">
      <template #modal-header="{ close }">
        <h5>Xác nhận chấm công</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img src="@/assets/img/noti-unsuccess2.svg" alt="question" />
        <h2 class="f18 py-3">Bạn chắc chắn xác nhận chứ?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="acceptSelect()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal xác nhận 1-->
    <b-modal id="modal-scoped" v-model="acceptOneModal">
      <template #modal-header="{ close }">
        <h5>Xác nhận chấm công</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img src="@/assets/img/noti-unsuccess2.svg" alt="question" />
        <h2 class="f18 py-3">Bạn chắc chắn xác nhận chứ?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="accept()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal không xác nhận select-->
    <b-modal id="modal-scoped" v-model="notAcceptModal">
      <template #modal-header="{ close }">
        <h5>Lý do không xác nhận</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <textarea v-model="textReason2" class="form-control" :maxlength="225" rows="3"></textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="notAcceptSelect()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal không xác nhận 1-->
    <b-modal id="modal-scoped" v-model="notAcceptOneModal">
      <template #modal-header="{ close }">
        <h5>Lý do không xác nhận</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <textarea v-model="textReasonTwo" class="form-control" :maxlength="225" rows="3"></textarea>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="notAccept()"> Xác nhận </b-button>
      </template>
    </b-modal>
    <!--Modal sale hủy-->
    <b-modal id="modal-scoped" v-model="cancelSaleModal">
      <template #modal-header="{ close }">
        <h5>Hủy chấm công</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img src="@/assets/img/noti-unsuccess2.svg" alt="question" />
        <h2 class="f18 py-3">Bạn chắc chắn hủy chứ?</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
        <b-button size="sm" variant="primary" @click="cancelSale()"> Xác nhận </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import { AttentdentService } from '@/services/attentdent.service'
  import { StaffService } from '@/services/staff.service'
  import Config from '../../thirdParty/config'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  const fieldTable = [
    { key: 'selected', label: '' },
    { key: 'staff', label: 'Nhân viên' },
    { key: 'province', label: 'Tỉnh/ thành phố' },
    { key: 'createdAt', label: 'Thời gian tạo' },
    { key: 'rangeTime', label: 'Khoảng thời gian' },
    { key: 'manager', label: 'Quản lý' },
    { key: 'image', label: 'Ảnh' },
    { key: 'type', label: 'Kiểu' },
    { key: 'reasonString', label: 'Loại' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'note', label: 'Ghi chú' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    components: {
      DateRangePicker,
    },
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        listTypeSale: Config.listTypeSale,
        fieldTable,
        filterTable: fieldTable,
        stateCheckAll: false,
        selectedStatus: null,
        dataTable: [],
        userData: JSON.parse(localStorage.getItem('userData')),
        typeSale: JSON.parse(localStorage.getItem('userData')).typeSale,
        superAdmin: Config.superAdmin,
        saleAdmin: Config.saleAdmin,
        transSale: Config.transSale,
        saleManager: Config.saleManager,
        saleLeader: Config.saleLeader,
        regionDirector: Config.regionDirector,
        search: {
          limit: 50,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
        pagination: {
          total: 0,
        },
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRange1: {
          startDate: null,
          endDate: null,
        },
        dataRegion: [],
        dataStaff: [],
        dataManager: [],
        stateAddtionTimekepping: Config.stateAddtionTimekepping,
        listReason: Config.listReason,
        selected: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        approvedModal: false,
        refuseModal: false,
        textReason: '',
        acceptModal: false,
        notAcceptModal: false,
        textReason2: '',
        cancelSaleModal: false,
        saleIdCancel: '',
        cancelId: '',
        approvedOneModal: false,
        approvedId: '',
        refuseOneModal: false,
        refuseId: '',
        textReasonOne: '',
        acceptOneModal: false,
        acceptId: '',
        notAcceptOneModal: false,
        notAcceptId: '',
        textReasonTwo: '',
        loading: true,
        typeCheckInOut: ['FORGOT_ATTN_IN', 'FORGOT_ATTN_OUT'],
        showLoading: false,
      }
    },
    created() {
      this.fetchData()
      if (!this.saleAdmin.includes(this.typeSale) || !this.superAdmin.includes(this.typeSale)) {
        this.getListStaffBySuperior()
      }
      this.getRegions()
      this.fetchSuperiors()
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        typeAddanceTimeKepping: 'common/typeAddanceTimeKepping',
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
    },
    methods: {
      // show ngày tháng trên bộ lọc
      transfromDate() {
        this.search.createdDateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.createdDateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
        this.search.startDate = moment(this.dateRange1.startDate).startOf('day').valueOf()
        this.search.endDate = moment(this.dateRange1.endDate).endOf('day').valueOf()
      },
      // thêm mới ccbs/nghỉ phép
      addTimekeeping() {
        this.$router.push('/timekeeping-add')
      },
      // chi tiết ccbs/nghỉ phép
      detailTimekeeping(item) {
        console.log('chuyển trang')
        window.open(`/timekeeping/${item.id}`)
      },
      // sửa ccbs/nghỉ phép
      editTimekeeping(item) {
        if (item.staffInfo.id === this.userData.userId) {
          this.$router.push({ path: `/timekeeping-edit/${item.id}` })
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      editTimekeepingHR(item) {
        if (item.staffInfo.id !== this.userData.userId) {
          this.$router.push({ path: `/timekeeping-edit/${item.id}` })
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      // hủy ccbs/nghỉ phép
      rejectTimekeeping(item) {
        if (item.staffInfo.id === this.userData.userId) {
          this.cancelSaleModal = true
          this.cancelId = item.id
          this.saleIdCancel = item.staffInfo.id
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      // confỉm hủy
      async cancelSale() {
        const data = await AttentdentService.saleCancel({
          attnAddId: this.cancelId,
          saleId: this.saleIdCancel,
        })
        if (data.success) {
          this.cancelSaleModal = false
          this.iconNoti = require('@/assets/img/noti-success2.svg')
          this.msgNoti = data.message
          this.notiModal = true
          this.fetchData()
        } else {
          this.cancelSaleModal = false
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = data.message
          this.notiModal = true
        }
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataRegion = data.data.map(e => {
            return { id: e.id, text: e.name }
          })
        }
      },
      // list nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userData.userId,
          })
          if (data.data.length > 0) {
            this.dataStaff = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // list nv cùng vùng
      async queryListStaff(e) {
        try {
          const data = await StaffService.getListLowerGrade({
            userId: this.userData.userId,
            region: [e],
          })
          if (data.data.length > 0) {
            this.dataStaff = data.data.map(e => {
              return {
                id: e.userId,
                text: e.name,
              }
            })
          }
        } catch (error) {}
      },
      // list quản lý
      async fetchSuperiors() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userData.userId,
          })
          if (data.success) {
            // this.dataManager.push({ id: 0, text: 'Tất cả' })
            data.data.map(e => {
              this.dataManager.push({ id: e.userId, text: `${e.name} - ${e.userName}` })
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      removeForm() {
        this.search = {
          limit: 50,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRange1 = {
          startDate: null,
          endDate: null,
        }
        this.selected = []
        this.fetchData()
      },
      // xuất file
      async exportFile() {
        try {
          this.showLoading = true
          if (this.search.userId === '0') this.search.userId = null
          if (this.search.regionId === '0') this.search.regionId = null
          if (this.search.status === 'false') this.search.status = null
          if (this.search.type === 'false') this.search.type = null
          delete this.search.limit
          delete this.search.page
          const res = await AttentdentService.timekeepingExport(this.search)
          if (res.success === false) {
            this.showFailMx(res.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      // checkbox - select all
      checkAll() {
        this.selected = []
        if (this.stateCheckAll === true) {
          this.dataTable.map(e => {
            if (e.status === this.selectedStatus) {
              this.selected.push(e.id)
            }
          })
        }
        if (this.stateCheckAll === false) {
          this.selected.splice(0, this.selected.length)
          this.selectedStatus = null
        }
      },
      // checkbox - select elemnet
      check(item) {
        if (this.selected.length > 0) {
          this.selectedStatus = item.status
        } else {
          this.selectedStatus = null
        }
      },
      // duyệt, từ chối
      async ApprovedOrReject(params) {
        try {
          const data = await AttentdentService.timekeepingApporovedOrReject(params)
          if (data.success) {
            this.approvedModal = false
            this.refuseModal = false
            this.approvedOneModal = false
            this.refuseOneModal = false
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = data.message
            this.notiModal = true
            this.selected = []
            this.fetchData()
          } else {
            this.approvedModal = false
            this.refuseModal = false
            this.approvedOneModal = false
            this.refuseOneModal = false
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.selected = []
          }
        } catch (error) {}
      },
      // xác nhận select
      showApprovedModal() {
        this.approvedModal = true
      },
      // confirm duyệt select
      approvedSelect() {
        this.ApprovedOrReject({
          isApprove: true,
          lstAttnId: this.selected,
          reason: '',
          superior: this.userData.username,
        })
      },
      // duyệt 1
      approvedTimekeeping(item) {
        if (item.staffInfo.userName !== this.userData.username) {
          this.approvedOneModal = true
          this.approvedId = item.id
        } else {
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
          this.notiModal = true
        }
      },
      // confirm duyệt 1
      approved() {
        this.ApprovedOrReject({
          isApprove: true,
          lstAttnId: [this.approvedId],
          reason: '',
          superior: this.userData.username,
        })
      },
      // từ chối select
      showRefuseModal() {
        this.refuseModal = true
      },
      // confirm từ chối select
      refuseSelect() {
        this.ApprovedOrReject({
          isApprove: false,
          lstAttnId: this.selected,
          reason: this.textReason,
          superior: this.userData.username,
        })
      },
      // từ chối 1
      refuseTimekeeping(item) {
        if (item.staffInfo.userName !== this.userData.username) {
          this.refuseOneModal = true
          this.refuseId = item.id
        } else {
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
          this.notiModal = true
        }
      },
      // confirm từ chối 1
      refuse() {
        this.ApprovedOrReject({
          isApprove: false,
          lstAttnId: [this.refuseId],
          reason: this.textReasonOne,
          superior: this.userData.username,
        })
      },
      // xác nhận, không xác nhận
      async AcceptOrNotAccept(params) {
        try {
          const data = await AttentdentService.timekeepingAcceptOrNotAccept(params)
          if (data.success) {
            this.acceptModal = false
            this.notAcceptModal = false
            this.acceptOneModal = false
            this.notAcceptOneModal = false
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = data.message
            this.notiModal = true
            this.selected = []
            this.fetchData()
          } else {
            this.acceptModal = false
            this.notAcceptModal = false
            this.acceptOneModal = false
            this.notAcceptOneModal = false
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.notiModal = true
            this.selected = []
          }
        } catch (error) {}
      },
      // xác nhận select
      showAcceptModal() {
        this.acceptModal = true
      },
      // confirm duyệt select
      acceptSelect() {
        const params = {
          isApprove: true,
          lstAttnId: this.selected,
          reason: '',
          superior: this.userData.username,
        }
        this.AcceptOrNotAccept(params)
      },
      // xác nhận 1
      acceptTimekeeping(item) {
        this.acceptOneModal = true
        this.acceptId = item.id
      },
      // confirm xác nhận 1
      accept() {
        this.AcceptOrNotAccept({
          isApprove: true,
          lstAttnId: [this.acceptId],
          reason: '',
          superior: this.userData.username,
        })
      },
      // không xác nhận select
      showNotAcceptModal() {
        this.notAcceptModal = true
      },
      // confirm không xác nhận select
      notAcceptSelect() {
        const params = {
          isApprove: false,
          lstAttnId: this.selected,
          reason: this.textReason2,
          superior: this.userData.username,
        }
        this.AcceptOrNotAccept(params)
      },
      // không xác nhận 1
      notAcceptTimekeeping(item) {
        this.notAcceptOneModal = true
        this.notAcceptId = item.id
      },
      // confirm không xác nhận 1
      notAccept() {
        this.AcceptOrNotAccept({
          isApprove: false,
          lstAttnId: [this.notAcceptId],
          reason: this.textReasonTwo,
          superior: this.userData.username,
        })
      },
      // dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true
          this.dataTable = []
          const data = await AttentdentService.listTimeKeeping(this.search)
          if (data.success) {
            this.dataTable = data.data
            this.pagination.total =
              data.totalPage && data.totalPage.total ? data.totalPage.total : 0
            this.loading = false
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message)
        }
      },

      openDetailStaff(item) {
        window.open(`/staff/detail/?id=${item.staffInfo.id}`, '_blank')
      },
    },
  }
</script>
<style scoped>
  .image {
    max-width: 4rem;
    max-height: 4rem;
  }
</style>
